import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import AppbarComponent from "./AppbarComponent";
import LogoComponent from "./LogoComponent";
import {Typography} from "@mui/material";
import FacebookButtonComponent from "./FacebookButtonComponent";

function HeaderComponent() {
    return (
        <div className="header">
            <Container maxWidth="lg">

                <Box sx={{ flexGrow: 1 }}>
                    <AppbarComponent />
                </Box>

                <LogoComponent />

                <Typography component="p" mb={5}>
                    Bienvenue sur la page Tendre Conception. Vous trouverez ici mes créations personnalisables de cadeaux de naissance (gâteaux de couches, prénoms en tricotin, attrapes rêve, bébés fimo).&nbsp;
                    <a href="https://www.facebook.com/TendreConception" target="_blank" rel="noreferrer">Abonnez-vous</a> pour recevoir les nouvelles créations originales.
                </Typography>

                <div className="fb-content">
                    <FacebookButtonComponent />
                </div>
            </Container>
        </div>
    );
}

export default HeaderComponent;
